import { Controller } from "@hotwired/stimulus"

// Copies the contents of a source field, confirming on the button itself.
export default class extends Controller {
    static targets = ["source", "button"]
    static values = { copied: String }

    async copy() {
        const text = this.sourceTarget.value

        try {
            await navigator.clipboard.writeText(text)
        } catch {
            // Clipboard access needs a secure context; selecting the text is
            // the fallback that works everywhere.
            this.sourceTarget.removeAttribute("aria-hidden")
            this.sourceTarget.select()
            document.execCommand("copy")
        }

        this.confirm()
    }

    confirm() {
        if (!this.hasButtonTarget) return

        const original = this.buttonTarget.innerHTML
        this.buttonTarget.textContent = this.copiedValue
        clearTimeout(this.reset)
        this.reset = setTimeout(() => { this.buttonTarget.innerHTML = original }, 2000)
    }
}
